import { IntlShape } from "react-intl";

type CanadianStateSelectProps = {
  intl: IntlShape;
  value: string;
  onChange: (value: string) => void;
  error?: string;
};

const CanadianStateSelect = ({
  intl,
  value,
  onChange,
  error,
}: CanadianStateSelectProps) => {
  const canadianStates = {
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NL: "Newfoundland and Labrador",
    NS: "Nova Scotia",
    NT: "Northwest Territories",
    NU: "Nunavut",
    // ON: "Ontario",
    PE: "Prince Edward Island",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  };

  return (
    <>
      <label className="text-input-container__input-label" htmlFor={"state"}>
        {intl.formatMessage({
          id: "home-register-select-province",
        })}
        <span className="required">*</span>
      </label>
      <div className="form-details__row--input">
        <select
          className={`${error ? "error" : ""}`}
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          <option value="">Select a province</option>
          {Object.entries(canadianStates).map(([code, name]) => (
            <option key={code} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      {error && <span className="error-message">{error}</span>}
    </>
  );
};

export default CanadianStateSelect;
